import React from 'react'
import Modal from 'react-bootstrap/Modal';
import DotLoader from "react-spinners/DotLoader";

function ModalCargando(props) {
    const {show}=props;
    return (
        <Modal
            show={show}
            backdrop="static"
            keyboard={false}
            centered
            contentClassName='bg-transparent text-light miLoader'>
            <Modal.Body>
                <div className='container-fluid text-center'>
                    <DotLoader className="text-center mx-auto" color='#F95E10' loading={show} size={200} />
                    <div className='text-light fw-bold fa-fade text-center'>Espere Por Favor ...</div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalCargando
